import { AuthService } from '@auth/auth.service';

export function appInitializer(authenticationService: AuthService) {
  return () =>
    new Promise((resolve) => {
      authenticationService
        .refreshToken()
        .subscribe()
        .add(() => authenticationService.loadSelf().then(resolve));
    });
}
